import { combineReducers } from 'redux';
import AuthReducer from './auth';
import UsersReducer from './users';
import AppReducer from './app';
import xmppSlice from './xmpp';
import RoomsReducer from './rooms';
import DirectChatReducer from './direct-chat';
import MedicalInstitutionsReducer from './medical-instituitions';
import PatientsReducer from './patients';
import AlertsReducer from './alerts';
import NewsReducer from './news';
import QuestionnairesReducer from './questionnaires';
import LifeIdReducer from './life-id';
import VitalHistoryReducer from './vital-history';
import AttachmentsReducer from './attachments';
import EventsReducer from './events';
import eVisitsReducer from './e-visits';
import reservationFormReducer from './reservation-form-slice';
import tagsPageReducer from './tags-page';
import programsReducer from './programs';
import twilioReducer from './twilio';

export default combineReducers({
  auth: AuthReducer,
  users: UsersReducer,
  app: AppReducer,
  [xmppSlice.name]: xmppSlice.reducer,
  rooms: RoomsReducer,
  directChat: DirectChatReducer,
  medicalInstitutions: MedicalInstitutionsReducer,
  patients: PatientsReducer,
  alerts: AlertsReducer,
  news: NewsReducer,
  questionnaires: QuestionnairesReducer,
  lifeId: LifeIdReducer,
  vitalHistory: VitalHistoryReducer,
  attachments: AttachmentsReducer,
  events: EventsReducer,
  eVisits: eVisitsReducer,
  reservationForm: reservationFormReducer,
  tagsPage: tagsPageReducer,
  programs: programsReducer,
  twilio: twilioReducer,
});
